<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3 15V5C3 3.89543 3.89543 3 5 3H15C16.1046 3 17 3.89543 17 5V12L12 17H5C3.89543 17 3 16.1046 3 15ZM16 11L11 16V11H16ZM6 7H10C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5H6C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7Z"
  />
</svg>
